(function ($) {
  'use strict';

  /**
   * Display totals for question pages
   */
  class PageTotals {
    constructor () {
      this.$pageTotal = $('.js-page-total');

      if (this.$pageTotal.length < 1) {
        return;
      }

      // Get all NumberFrequency fields on this page
      this.$numberFrequencyFields = $('.js-field-panel[data-question-type="NumberFrequency"]');
      this.$radioBoolean = $('.js-field-panel[data-question-type="RadioBoolean"]');
      this.$numberFields = $('.js-field-panel[data-question-type="Number"]');

      // If Validation errors panel is on the page
      // it means there's data in the request hence we want to display updated totals
      if ($('.js-validation-errors li').length > 0) {
        this.calculatePageTotal();
      }

      // Add event listeners to child elements
      this.$numberFrequencyFields.on('keyup', 'input[type="number"]', $.proxy(this.calculatePageTotal, this));
      this.$numberFrequencyFields.on('click', 'input[type="checkbox"]', $.proxy(this.calculatePageTotal, this));
      this.$numberFrequencyFields.on('change', 'select', $.proxy(this.calculatePageTotal, this));
      this.$numberFields.on('keyup', 'input[type="number"]', $.proxy(this.calculatePageIntTotal, this));
      this.$numberFields.on('click', 'input[type="checkbox"]', $.proxy(this.calculatePageIntTotal, this));
      this.$radioBoolean.on('key', 'input[type="radio"]', $.proxy(this.calculatePageTotal, this));
      this.$radioBoolean.on('click', 'input[type="radio"]', $.proxy(this.calculatePageTotal, this));
    }

    calculatePageIntTotal () {
      let total = 0;
      for (let i = 0; i < this.$numberFields.length; i++) {
        total += parseInt(this.getNumberFieldValue(this.$numberFields.eq(i)));
      }

      // Update the page total
      this.$pageTotal.html(total);
    }

    calculatePageTotal () {
      let total = 0;

      for (let i = 0; i < this.$numberFrequencyFields.length; i++) {
        total += parseFloat(this.getFieldValue(this.$numberFrequencyFields.eq(i)));
      }

      // Update the page total
      this.$pageTotal.html(total.toFixed(2));
    }

    getNumberFieldValue ($field) {
      let $numberField = $field.find('input[type="number"]:enabled, input[type="hidden"]');
      let $naCheckbox = $field.find('input[type="checkbox"].js-na-checkbox:enabled');

      if ($numberField.length < 1 || $naCheckbox.is(':checked')) {
        return 0;
      }

      return $numberField.val() !== '' ? $numberField.val() : 0;
    }

    getFieldValue ($field) {
      let $numberField = $field.find('input[type="number"]:enabled');
      let $frequencyField = $field.find('select:enabled');
      let $naCheckbox = $field.find('input[type="checkbox"].js-na-checkbox:enabled');

      if ($numberField.length < 1 || $frequencyField.length < 1 || $naCheckbox.is(':checked')) {
        return 0;
      }

      let number = $numberField.val() !== '' ? $numberField.val() : 0;
      let frequency = $frequencyField.val();

      switch (frequency.toLowerCase()) {
        case 'weekly':
          return (number * 52) / 12;
        case 'fortnightly':
          return (number * 26) / 12;
        case 'monthly':
          return number;
        case 'quarterly':
          return number / 3;
        case 'annually':
          return number / 12;
        case '4 weekly':
          return (number * 13) / 12;
        default:
          return 0;
      }
    }
  }

  this.PageTotals = PageTotals;
}).call(Framework, jQuery);
